import { createContext, useContext, ReactNode, useEffect } from 'react';
import { useAuth, UseAuthReturn } from '../hooks/useAuth';
import { setAuthHeadersGetter } from '../utils/apiClient';

const AuthContext = createContext<UseAuthReturn | null>(null);

interface AuthProviderProps {
  children: ReactNode;
}

/**
 * Auth context provider - wraps the useAuth hook for global access
 */
export function AuthProvider({ children }: AuthProviderProps) {
  const auth = useAuth();

  // Set auth headers getter for apiClient
  useEffect(() => {
    setAuthHeadersGetter(auth.getAuthHeaders);
  }, [auth.getAuthHeaders]);

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}

/**
 * Hook to access auth context
 */
export function useAuthContext(): UseAuthReturn {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
}

export default AuthProvider;
